import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';
import './styles/typography.css';
import './styles/animations.css';
import './index.css';
import App from './App';

// Remove static landing page content before React mounts (visible to no-JS crawlers like Stripe)
const staticLanding = document.getElementById('static-landing');
if (staticLanding) staticLanding.remove();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
